import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import axios from 'axios';
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// ----- Styled Components -----
const Loader = () => (
  <div style={{ textAlign: "center", padding: "1rem" }}>
    <div className="spinner" />
    <style>{`
      .spinner {
        width: 28px;
        height: 28px;
        border: 3px solid #e0e0e0;
        border-top: 3px solid #3772FF;
        border-radius: 50%;
        animation: spin 0.7s linear infinite;
        margin: auto;
      }
      @keyframes spin {
        to { transform: rotate(360deg); }
      }
    `}</style>
  </div>
);

const ModalOverlay = styled.div`
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(0,0,0,0.35);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

const ModalContainer = styled.div`
  background: #fff;
  border-radius: 14px;
  width: 400px;
  max-width: 90%;
  padding: 30px 25px;
  box-shadow: 0 4px 20px rgba(35,62,88,0.2);
  display: flex;
  flex-direction: column;
`;

const ModalHeader = styled.h3`
  font-size: 1.4rem;
  font-weight: 700;
  margin-bottom: 20px;
  color: #21325b;
`;

const ModalField = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
`;

const Label = styled.label`
  font-size: 1rem;
  margin-bottom: 5px;
  color: #182237;
`;

const Input = styled.input`
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #dcdcdc;
  font-size: 1rem;
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
`;
const ErrorText = styled.span`
  color: #d24949;
  font-size: 0.95rem;
  margin-top: 4px;
`;

const Button = styled.button`
  padding: 10px 18px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 1rem;
  border: none;
  cursor: pointer;
  color: #fff;
  background: ${props => props.variant === 'cancel' ? '#d24949' : '#426dff'};
  &:hover {
    background: ${props => props.variant === 'cancel' ? '#b33b3b' : '#305de2'};
  }
`;

// ----- AddStoreModal Component -----
export default function AddStoreModal({ isOpen, onClose, onStoreAdded, isEdit = false, editStore = null, onStoreUpdated }) {
  const [formData, setFormData] = useState({ city: '', state: '', friendly_name: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [fieldErrors, setFieldErrors] = useState({});
const token = localStorage.getItem('access_token');
  const headers = { Authorization: `Bearer ${token}` };
const validateForm = (fields = formData) => {
  let errors = {};
  console.log("Form Data :",formData)

  const nameRegex = /^[a-zA-Z\s'-]+$/; // letters, spaces, apostrophes, hyphens for city and state
  const friendlyNameRegex = /^[a-zA-Z0-9\s'-]{3,50}$/; // alphanumeric plus spaces, apostrophes, hyphens, 3-50 chars

  if (!fields.friendly_name.trim()) {
    errors.friendly_name = "Friendly Name is required";
  } 
  // else if (!friendlyNameRegex.test(fields.friendly_name)) {
  //   errors.friendly_name = "Friendly Name must be 3-50 characters, alphanumeric and may include spaces or - '";
  // }

  if (!fields.city.trim() ) {
    errors.city = "City is required";
  } else if (!nameRegex.test(fields.city)) {
    errors.city = "City contains invalid characters";
  }

  if (!fields.state.trim()) {
    errors.state = "State is required";
  } else if (!nameRegex.test(fields.state)) {
    errors.state = "State contains invalid characters";
  }

  return errors;
};

  // Initialize form data on edit or reset on add/close
  useEffect(() => {
    if (isEdit && editStore) {
      setFormData({
        city: editStore.city || '',
        state: editStore.state || '',
        friendly_name: editStore.friendly_name || ''
      });
      setError('');
            setFieldErrors({});

    } else {
      setFormData({ city: '', state: '', friendly_name: '' });
      setError('');
            setFieldErrors({});

    }
  }, [isEdit, editStore, isOpen]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

 const handleSubmit = async () => {
  setError('');
  const errors = validateForm();
  if (Object.keys(errors).length > 0) {
    setError('Please fix the form errors before submitting.');
    setFieldErrors(errors); // you'll need to add state for fieldErrors and display below inputs
    return;
  }
  setLoading(true);

  try {
      if (isEdit && editStore) {
        // Update store - send all form data
        const res = await axios.post(`${BACKEND_URL}/store/edit/${editStore.id}`, formData,{headers :headers});
        if (res.status === 200) {
          onStoreUpdated && onStoreUpdated();
          onClose();
        }
      } else {
        // Add new store
        const res = await axios.post(`${BACKEND_URL}/store`, formData,{headers :headers});
        if (res.status === 201) {
          setFormData({ city: '', state: '', friendly_name: '' });
          onStoreAdded && onStoreAdded();
          onClose();
        }
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong');
    } finally {
      setLoading(false);
    }
};


  return (
    <ModalOverlay>
      {loading && <Loader />}
      <ModalContainer>
        <ModalHeader>{isEdit ? 'Edit Store' : 'Add New Store'}</ModalHeader>


        <ModalField>
          <Label>Friendly Name<span style={{ color: 'red', marginLeft: '4px' }}>*</span></Label>
          <Input name="friendly_name" value={formData.friendly_name} onChange={handleChange} />
                    {fieldErrors.friendly_name && <ErrorText>{fieldErrors.friendly_name}</ErrorText>}

        </ModalField>

        <ModalField>
          <Label>City<span style={{ color: 'red', marginLeft: '4px' }}>*</span></Label>
          <Input name="city" value={formData.city} onChange={handleChange} />
                              {fieldErrors.city && <ErrorText>{fieldErrors.city}</ErrorText>}

        </ModalField>

        <ModalField>
          <Label>State<span style={{ color: 'red', marginLeft: '4px' }}>*</span></Label>
          <Input name="state" value={formData.state} onChange={handleChange} />
                           {fieldErrors.state && <ErrorText>{fieldErrors.state}</ErrorText>}

        </ModalField>

        {error && <div style={{ color: '#d24949', marginBottom: 10 }}>{error}</div>}



                        <Label style={{marginTop:'40px'}}><span style={{ color: 'red', marginLeft: '4px' }}>*</span> marked fields are required.</Label>

        <ButtonRow>
          
          <Button variant="cancel" onClick={onClose}>Cancel</Button>
          <Button onClick={handleSubmit} disabled={loading}>
            {loading ? (isEdit ? 'Updating...' : 'Adding...') : (isEdit ? 'Update Store' : 'Add Store')}
          </Button>
        </ButtonRow>
      </ModalContainer>
    </ModalOverlay>
  );
}
